<template>
  <v-container fluid>
    <div v-if="unassignedSchedules && unassignedSchedules.length > 0">
      <v-alert type="warning" :colored-border="true" border="left">
        <div class="text-subtitle-1">The following schedule has no teacher assigned.</div>
        <ul class="text-body-2 my-2">
          <li v-for="schedule in unassignedSchedules" :key="schedule.id">
            <span v-if="schedule.rrule">
              {{ schedule | scheduleText }}
            </span>
            <span v-else>
              {{ schedule.startDate | formatDate }} {{ schedule.startTime | formatTime }}
            </span>
          </li>
        </ul>
      </v-alert>
    </div>
    <v-card>
      <v-card-text>
        <!-- <v-simple-table class="mb-10">
          <tbody>
            <tr v-for="schedule in course.courseSchedules" :key="schedule.id">
              <td style="width: 50px">
                <v-icon v-if="schedule.rrule"> mdi-calendar-sync </v-icon>
                <v-icon v-else> mdi-calendar-outline </v-icon>
              </td>
              <td v-if="schedule.rrule">
                {{ schedule | scheduleText }}
                <div
                  v-if="
                    schedule.scheduleExclusions &&
                    schedule.scheduleExclusions.length > 0
                  "
                >
                  Excludes {{ formatExcludeDates(schedule) }}
                </div>
                <div v-if="schedule.remark">Remark: {{ schedule.remark }}</div>
              </td>
              <td v-else>
                <span
                  :class="
                    schedule.scheduleExclusions &&
                    schedule.scheduleExclusions.length > 0
                      ? 'text-decoration-line-through'
                      : ''
                  "
                >
                  {{ schedule.startDate | formatDate }}
                </span>
              </td>
              <td>
                {{ schedule.startTime | formatTime }} -
                {{ schedule.endTime | formatTime }}
              </td>
              <td>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="mx-auto" max-width="400" width="200" tile>
                    <v-list dense>
                      <v-list-item-group color="primary">
                        <v-list-item
                          :to="{
                            name: 'CourseSchedule',
                            params: {
                              courseId: course.id,
                              scheduleId: schedule.id,
                            },
                          }"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-icon>mdi-pencil</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Edit Schedule</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="deleteSchedule(schedule.id)">
                          <v-list-item-icon class="mr-2">
                            <v-icon>mdi-delete</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Delete Schedule</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-menu>
              </td>
            </tr>
          </tbody>
        </v-simple-table> -->
        <v-sheet tile height="54" class="d-flex">
          <div
            class="text-h5 text-center hidden-sm-and-up"
            v-if="$refs.calendar"
          >
            {{ $refs.calendar.title }}
          </div>
          <v-btn icon @click="$refs.calendar.prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-spacer />
          <div
            class="text-h5 ml-2 ml-lg-10 hidden-sm-and-down"
            v-if="$refs.calendar"
          >
            {{ $refs.calendar.title }}
          </div>
          <v-spacer />
          <v-btn icon @click="$refs.calendar.next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-sheet>
        <v-sheet>
          <v-calendar
            ref="calendar"
            v-model="value"
            :type="type"
            :events="events"
            @change="getEvents"
            :key="timestamp"
            :event-color="getEventColor"
            @click:event="showEvent"
            @click:date="addEvent"
          />
        </v-sheet>
      </v-card-text>

      <div class="d-flex justify-center py-5 text-caption">
        <v-sheet dark class="pa-1 px-2 mx-2" rounded color="primary">
          Active
        </v-sheet>
        <v-sheet dark class="pa-1 px-2 mx-2" rounded color="grey darken-1">
          Canceled
        </v-sheet>
      </div>
    </v-card>

    <v-dialog v-if="selectedScheduleId" v-model="scheduleDialog">
      <v-sheet>
          <course-schedule
            :titleColor="selectedEvent.color"
            @canceledClass="scheduleEventChanged"
            @undoCancelation="scheduleEventChanged"
            @deletedSchedule="deletedSchedule"
            :scheduleId="selectedScheduleId"
            :scheduleDate="selectedEvent.start"
            :allowDelete="true"
            :viewCourse="false"
            :key="`${selectedScheduleId}_${selectedEvent.start}`"
          />

          <div class="d-flex justify-center">
            <v-btn class="my-5" text color="secondary" @click="scheduleDialog = false">
              Close
            </v-btn>
          </div>
        </v-sheet>
    </v-dialog>

  </v-container>
</template>

<script>
import { rrulestr } from "rrule";
import moment from "moment";
import { DateTime } from 'luxon';
const CourseSchedule = () => import("@/components/course/CourseSchedule.vue");

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      assignTeacher: null,
      selectedEvent: null,
      googleCalendarEventDialog: false,
      scheduleDialog: false,
      events: [],
      value: null,
      type: "month",
      selectedScheduleId: null,
      unassignedSchedules: [],
      timestamp: Date.now(),
    };
  },
  filters: {
    formatTime(time) {
      return moment(time, "HH:mm").format("h:mm a");
    },
    formatDate(date) {
      return moment(date).format("ddd, MMM DD, yyyy");
    },
  },
  methods: {
    formatExcludeDates(schedule) {
      if (
        schedule.scheduleExclusions &&
        schedule.scheduleExclusions.length > 0
      ) {
        const dates = schedule.scheduleExclusions
          .map((d) => moment(d.excludeDate).format("ddd MMM, DD YYYY"))
          .join(", ");
        return dates;
      } else {
        return "";
      }
    },
    getEvents({ start, end }) {
      this.initEvents({ start, end });
    },
    initEvents({ start, end }) {
      let events = [];
      // const schedulesText = [];
      if (!this.course || !this.course.courseSchedules) {
        return events;
      }

      this.course.courseSchedules.forEach((schedule) => {
        //Recurring
        if (schedule.rrule) {
          // console.log(start)
          // console.log(end)
          const scheduleEvents = this.processRecurringRules(
            schedule,
            start,
            end
          );
          events = events.concat(scheduleEvents);
        }
        //One Time
        else {
          const startTime = moment(schedule.startTime, "HH:mm").format(
            "h:mm a"
          );
          const endTime = moment(schedule.endTime, "HH:mm").format("h:mm a");
          const canceled = schedule.scheduleExclusions.length > 0;
          events.push({
            id: schedule.id,
            name: `${startTime} - ${endTime}`,
            start: schedule.startDate,
            end: schedule.startDate,
            timed: false,
            color: canceled ? "grey darken-1":'primary'
          });
        }
      });

      this.events = events;

      console.log(this.events);

      // this.schedulesText = schedulesText;
    },
    processRecurringRules(schedule, start, end) {
      const events = [];
      // const schedulesText = [];

      const exclusions = schedule.scheduleExclusions;
      let excludeDates = [];
      if (exclusions && exclusions.length > 0) {
        excludeDates = exclusions.map((e) => e.excludeDate);
      }
      const rule = rrulestr(schedule.rrule);
      const allDates = rule.all(function (date, i){return i < 300});
      //new to filter dates by start and end
      const min = start ? moment(start.date).format("YYYY-MM-DD") : null;
      const max = end ? moment(end.date).format("YYYY-MM-DD") : null;
      const startTime = moment(schedule.startTime, "HH:mm").format("h:mm a");
      const endTime = moment(schedule.endTime, "HH:mm").format("h:mm a");
// console.log(schedule.rrule);
// console.log(allDates);

      allDates.forEach((d) => {
        // const eventDate = moment.utc(d).local().startOf('day');
        const localDate = DateTime.fromJSDate(d)
                              .toUTC()
                              .setZone('local', { keepLocalTime: true })
                              .toJSDate();
        const eventDate = moment(localDate);
        const date = eventDate.format("YYYY-MM-DD");
        const startOfDate = eventDate.startOf('day');

        //skip if date is not inclusive of the range seeked
        if (min && max && !startOfDate.isBetween(min, max, undefined, "[]")) {
          // console.log(`outside range ${date}`)
          return;
        }

        //add events only if not in course schedule exclusion list
        const canceled = excludeDates.length > 0 && excludeDates.includes(date);
        events.push({
          id: schedule.id,
          name: `${startTime} - ${endTime}`,
          start: localDate,
          end: localDate,
          timed: false,
          canceled,
          color: canceled ? "grey darken-1":'primary'
        });
      });

      return events;
    },
    
    showEvent({ event }) {
      this.selectedEvent = event;
      this.selectedScheduleId = event.id;
      this.scheduleDialog = true;
    },
    getEventColor(event) {
      return event.color;
    },
    addEvent( {date} ) {
      this.$router.push({name: 'CourseSchedule', params: {courseId: this.course.id, date, scheduleMode: 'single'}})
    },
    scheduleEventChanged( value ) {
      // const event = this.events.find(
      //   (e) => e.id == schedule.id && e.start == scheduleDate
      // )
      // event.color = "grey darken-1";
      
      // this.selectedScheduleId = null;
      // this.scheduleDialog = false;
      // this.selectedEvent = null;
      console.log('changed schedule: ', value.schedule)
      console.log('schedule date', value.scheduleDate)

      this.timestamp = Date.now();
    },
    deletedSchedule(scheduleId){
      const index = this.course.courseSchedules.findIndex(
        (s) => s.id == scheduleId
      );
      this.course.courseSchedules.splice(index, 1);
      this.scheduleDialog = false;
      this.timestamp = Date.now(); //refreshes calendar
    },
    unassignedCheck(course){
      const unassignedSchedules = []

      if(course && course.courseSchedules){
        course.courseSchedules.forEach( (schedule) => {
          const ts = schedule.courseTeacherSchedules;

          if(!ts || ts.length < 1){
            unassignedSchedules.push(schedule);
          }
        })
      }
      return unassignedSchedules;
    }
  },
  mounted() {
    console.log("initializing calendar");
    // this.initEvents({});

    this.unassignedSchedules = this.unassignedCheck(this.course);
  },
  components: {
    CourseSchedule
  },
};
</script>

<style>
</style>